import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { ToastrModule } from 'ngx-toastr';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { langInterceptor } from './core/interceptors/lan-interceptor';
import { headersInterceptor } from './core/interceptors/header-interceptor';

registerLocaleData(localeAr);

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'ar',
    },

    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),

    provideAnimationsAsync(),
  
    provideHttpClient(
      withFetch(),
      withInterceptors([headersInterceptor, langInterceptor])
    ),

    importProvidersFrom(
      ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        timeOut: 3000,
        closeButton: true,
         extendedTimeOut: 1000,
        progressBar: false,
      })
    ),
  ],
};